import { render, staticRenderFns } from "./customsClearanceModeInformation.vue?vue&type=template&id=0ebea7ad&scoped=true&"
import script from "./customsClearanceModeInformation.vue?vue&type=script&lang=js&"
export * from "./customsClearanceModeInformation.vue?vue&type=script&lang=js&"
import style0 from "./customsClearanceModeInformation.vue?vue&type=style&index=0&id=0ebea7ad&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebea7ad",
  null
  
)

export default component.exports